import React, { useState, useEffect } from "react";
import { Select, Spin } from "antd";
import formService from "../../services/form";

export default function FormsWithWorkflowList({ onChange, value, ...props }) {
	const [forms, setForms] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await formService.getFormsWithWorkflow();
			setForms(response);
		} catch (error) {
			console.error("Failed to fetch forms with workflow status:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleChange = (newValue) => {
		if (onChange) {
			onChange(newValue);
		}
	};

	return (
		<Spin spinning={loading}>
			<Select
				showSearch
				optionFilterProp='children'
				style={{ width: "100%" }}
				size='large'
				value={value}
				onChange={handleChange}
				placeholder='Select Form (No Workflow)'
				allowClear
				{...props}
			>
				{forms.map((form) => (
					<Select.Option key={form.id} value={form.id}>
						{form.name}
					</Select.Option>
				))}
			</Select>
		</Spin>
	);
}
